/** TabContainer registration: the parser. Render registration lives in `index.r3f.ts`. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseTabContainer } from './parser';
const tabContainerRegistration = {
    typeName: 'TabContainer',
    parser: parseTabContainer,
};
nodeRegistry.register(tabContainerRegistration);
//# sourceMappingURL=index.js.map